import apolloClient from '../../utils/apollo-client';
import {getLead as query} from '../graphql/get-lead';

export default async function () {
  const response = await apolloClient().then((client) =>
    client
      .query({
        query,
      })
      .catch((error) => {
        if (error.networkError) {
          if (error.networkError?.extensions?.response?.status === 404) {
            const e = new Error('Lead not found');

            e.status = 404;
            throw e;
          } else if (error.networkError?.message) {
            throw new Error(error.networkError?.message);
          }
        }
        throw new Error(error);
      }),
  );

  return response.data.getLead;
}
